import { Module } from 'vuex';
import { state, ITrackingState } from './state';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { IRootState } from '../mxr-store/state';


export const TrackingStore: Module<ITrackingState, IRootState> = {
    actions,
    state,
    getters,
    mutations,
};
